$('.js-slider--keystones').slick({
    dots: false,
    arrows: false,
    slidesToShow: 4,
    infinite: false,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                infinite: true,
                centerMode: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                infinite: true,
                centerPadding: '60px',
                centerMode: true,
                variableWidth: true
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                infinite: true,
                centerPadding: '30vw',
                centerMode: true,
                variableWidth: true
            }
        },
        {
            breakpoint: 500,
            settings: {
                slidesToShow: 1,
                infinite: true,
                centerPadding: '20vw',
                centerMode: true,
                variableWidth: true
            }
        },
        {
            breakpoint: 400,
            settings: {
                slidesToShow: 1,
                infinite: true,
                centerPadding: '15vw',
                centerMode: true,
                variableWidth: true
            }
        }
    ]
});

$('.js-slider--steps').slick({
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 4,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                arrows: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                arrows: true
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                arrows: true
            }
        }
    ]
});